import { NgClass, NgIf, NgStyle } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzButtonType } from 'ng-zorro-antd/button/button.component';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { CrmTranslatePipe } from 'common-module/translate';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.less'],
  imports: [NzIconModule, NgIf, CrmTranslatePipe, NzButtonModule, NgClass, NgStyle],
  standalone: true
})
export class ButtonComponent implements OnInit {
  @Input() public id!: string;
  @Input() public title?: string;
  @Input() public iconType?: string;
  @Input() public buttonType?: NzButtonType = 'primary';
  @Input() public buttonClass?: string;
  @Input() public loading?: boolean;
  @Input() public disabled?: boolean;
  @Input() public href?: string;
  @Input() public style?: any;
  @Input() public type?: string;

  constructor() {}

  public ngOnInit() {}
}
